import React, { Component } from "react";
import CustomButton from "../../../common/Button";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import clsx from 'clsx';

import "./index.css";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles1 = makeStyles(theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));


function MySnackbarContentWrapper(props) {
  const classes = useStyles1();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

export default class LandingSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email:'',
      purpose:'',
      affilation:'',
      name:'',
      isModalOpen:false,
      errorSnackBar:false,
      successSnackBar:false,
    }
  }
  handleClose = () => {
    this.setState({isModalOpen:false})
  } 
  handleOpen = () => {
    this.setState({isModalOpen:true})
  }
  handleChange = (name, event )=> {
    this.setState({ [name]: event.target.value });
  };

  close = (name) => {
    this.setState({ [name]: false});
  }

  open = (name) => {
    this.setState({[name]: true});
  }

  vaildateData = (email, purpose) => {
    // should return true if validated 
    // else return false
    console.log(email,purpose)
    return email !== '' && purpose.length > 10;

  }
  handleSendToServer = () => {
    const { email, purpose, affilation , name}  = this.state;
    if(this.vaildateData(email, purpose))   {
        console.log("SEND: ", email,purpose);
        fetch('https://rakshakconfirmation.herokuapp.com/request',
          {method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
            body: JSON.stringify({name,affilation,email,purpose})})
            .then(data => {
              this.open('successSnackBar')
              this.handleClose();
            }).catch(e=>console.log(e))

    } else {
      // TODO: show error diloag
      this.open('errorSnackBar')
    }
  }
  render() {
    return (
      <div>
        <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={this.state.successSnackBar}
        autoHideDuration={6000}
        onClose={()=> this.close('successSnackBar')}
      >
        <MySnackbarContentWrapper
          onClose={()=> this.close('successSnackBar')}
          variant="success"
          message="Your Request submited, We will get back to you soon!"
        />
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={this.state.errorSnackBar}
        autoHideDuration={6000}
        onClose={()=> this.close('errorSnackBar')}
      >
        <MySnackbarContentWrapper
          onClose={()=> this.close('errorSnackBar')}
          variant="error"
          message="Your email is not valid or purpose too short!"
        />
      </Snackbar>
        <Dialog
          open={this.state.isModalOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Download</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To Download this dataset, please enter your email address
              here along with purpose of use of this dataset. this request will be check and you will be notified by email.
            </DialogContentText>
            <TextField
            required
            autoFocus
            margin="normal"
            variant="outlined"
            id="name-1"
            label="Full Name"
            type="text"
            onChange={(e) => this.handleChange('name',e)}
            fullWidth
          />
          <TextField
          required
            autoFocus
            margin="normal"
            variant="outlined"
            id="affilation"
            label="Affiliation"
            type="text"
            onChange={(e) => this.handleChange('affilation',e)}
            fullWidth
          />

            <TextField
            required
              autoFocus
              margin="normal"
              variant="outlined"
              id="name"
              label="Email Address"
              type="email"
              onChange={(e) => this.handleChange('email',e)}
              fullWidth
              
            />
            <TextField
            required
              autoFocus
              margin="normal"
              variant="outlined"
              id="purpose"
              label="Dataset need?"
              type="text"
              onChange={(e) => this.handleChange('purpose',e)}
              fullWidth
            />   
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={this.handleClose}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.handleSendToServer}> 
              Request
            </Button>
          </DialogActions>
        </Dialog>
        <div className="landing-header">
          <h1>EmoSpeech Dataset</h1>
          <h3>India's first keyword-emotion dataset</h3>
        </div>
        <div className="header-main-section">
          <div className="header-download-section">
            <CustomButton id="downlood" text="Download" colored onClick={this.handleOpen} />
            <CustomButton
              text="contribute"
              onClick={() =>
                window.open("https://quickspeech-in.web.app", "_blank")
              }
            />
          </div>
          <div className="header-image no-mobo">
            <img src={require("../../../assets/wave.png")} />
          </div>
        </div>
      </div>
    );
  }
}
